import {
  SELECT_ALL_TRAFFIC_OPERATORS,
  DESELECT_ALL_TRAFFIC_OPERATORS,
  TRAFFIC_OPERATORS_CHECKED,
} from "./types/TrafficOperatorActionTypes";

export function onSelectAllTrafficOperators(nodes) {
  return {
    type: SELECT_ALL_TRAFFIC_OPERATORS,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllTrafficOperators() {
  return {
    type: DESELECT_ALL_TRAFFIC_OPERATORS,
  };
}

export function trafficOperatorsCheckedActionCreator(
  checkedTrafficOperators,
  reportDefinition
) {
  return {
    type: TRAFFIC_OPERATORS_CHECKED,
    checkedTrafficOperators,
    reportDefinition,
  };
}
